"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** Class handling visibility. */
var Display = /** @class */ (function () {
    /** Initializing visibility. */
    function Display(visible) {
        this.setVisibility(visible);
    }
    Object.defineProperty(Display.prototype, "isVisible", {
        /** Telling if element is visible. */
        get: function () {
            return this.visible;
        },
        enumerable: false,
        configurable: true
    });
    /** Showing element. */
    Display.prototype.show = function () {
        return this.setVisibility(true);
    };
    /** Hiding element. */
    Display.prototype.hide = function () {
        return this.setVisibility(false);
    };
    /** Toggling element visibility. */
    Display.prototype.toggle = function () {
        return this.setVisibility(!this.visible);
    };
    /** Setting visibility to given status. */
    Display.prototype.setVisibility = function (visible) {
        this.visible = visible;
        return this;
    };
    return Display;
}());
exports.default = Display;
